/* Product page: gallery thumbnails, variant selection, quantity stepper, sticky bar. */
(function () {
  "use strict";

  document.querySelectorAll("[data-product-root]").forEach(function (root) {
    initGallery(root);
    initVariantPicker(root);
    initQuantity(root);
    initStickyBar(root);
  });

  function initGallery(root) {
    var main = root.querySelector("[data-gallery-main-img]");
    var thumbs = root.querySelectorAll("[data-gallery-thumb]");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var newSrc = thumb.dataset.fullSrc;
        if (!newSrc) return;
        main.src = newSrc;
        main.alt = thumb.dataset.alt || main.alt;
        thumbs.forEach(function (t) { t.setAttribute("aria-current", "false"); });
        thumb.setAttribute("aria-current", "true");
      });
    });
  }

  function initVariantPicker(root) {
    var form = root.querySelector(".product-form");
    if (!form) return;
    var swatches = root.querySelectorAll("[data-variant-value]");
    var idInput = form.querySelector("[data-variant-id-input]");
    var priceEl = root.querySelector("[data-product-price]");
    var addBtn = form.querySelector("[data-add-to-cart]");
    var variantsJson = root.dataset.variants;
    var variants = [];
    try { variants = JSON.parse(variantsJson || "[]"); } catch (e) { variants = []; }

    function selectedOptions() {
      var groups = {};
      root.querySelectorAll("[data-option-index]").forEach(function (group) {
        var index = group.dataset.optionIndex;
        var active = group.querySelector("[aria-current='true']");
        if (active) groups[index] = active.dataset.variantValue;
      });
      return groups;
    }

    function findMatchingVariant() {
      var selected = selectedOptions();
      return variants.find(function (variant) {
        return Object.keys(selected).every(function (index) {
          return variant.options[parseInt(index, 10)] === selected[index];
        });
      });
    }

    function updateUI() {
      var variant = findMatchingVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price_html;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.querySelector("[data-add-to-cart-label]").textContent = variant.available
          ? addBtn.dataset.labelAvailable
          : addBtn.dataset.labelSoldOut;
      }
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener("click", function () {
        var group = swatch.closest("[data-option-index]");
        group.querySelectorAll("[data-variant-value]").forEach(function (s) {
          s.setAttribute("aria-current", "false");
        });
        swatch.setAttribute("aria-current", "true");
        updateUI();
      });
    });
  }

  function initQuantity(root) {
    root.querySelectorAll("[data-qty-wrapper]").forEach(function (wrapper) {
      var input = wrapper.querySelector("input");
      wrapper.querySelectorAll("[data-qty-step]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var step = parseInt(btn.dataset.qtyStep, 10);
          var min = parseInt(input.min || "1", 10);
          var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
          input.value = next;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  function initStickyBar(root) {
    var bar = root.querySelector("[data-sticky-add-bar]");
    var anchor = root.querySelector("[data-add-to-cart]");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle("is-visible", !entry.isIntersecting);
        });
      },
      { rootMargin: "-120px 0px 0px 0px" }
    );
    io.observe(anchor);

    var barBtn = bar.querySelector("[data-sticky-add-trigger]");
    if (barBtn) {
      barBtn.addEventListener("click", function () {
        var form = root.querySelector(".product-form");
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }
})();
